import React, { Component } from "react";
import ComponentToPrint from './ComponentToPrint'

class HOC extends Component {
  render() {
    return <ComponentToPrint data={this.props.data} />;
  }
}
export default HOC;
